var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-card',[_c('div',{staticStyle:{"width":"100%","height":"800px"},attrs:{"id":"chartTagTree"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }